Apt.fn.make('share', {
	/**
	 * Initialize module
	 *
	 * @param {Object} options
	 * @returns {Object}
	 */
	init: function(options) {
		var scope = this;

		scope.conf = $.extend({
			namespace: 'share' + Math.random()
		}, options);

		scope.show(options);

		return scope;
	},

	/**
	 * Display share modal
	 *
	 * @param {Object} options
	 */
	show: function(options) {
		var priv = this.$private;

		priv.options = $.extend({
			title: $._doc.title,
			url: $.routes.uri().url
		}, options);

		Apt.modal.open({
			content: $.view.render('share.modal', priv.options),
			width: 375,
			onHide: function() {
				$.events.reset('shareForm');
			}
		});
	},

	/**
	 * Destroy module
	 */
	_destruct: function() {
		$.events.reset(this.conf.namespace);
	}
});